import { DATADOG_ENVIRONMENTS } from './constants.js';
export class InvalidDatadogEnvironmentError extends Error {
    constructor(value) {
        const valid = Object.values(DATADOG_ENVIRONMENTS).join(', ');
        const message = value
            ? `Invalid DataDog environment: "${value}". Must be one of: ${valid}`
            : `DataDog environment is required. Must be one of: ${valid}`;
        super(message);
        this.name = 'InvalidDatadogEnvironmentError';
    }
}
function isValidDatadogEnvironment(env) {
    const validEnvironments = Object.values(DATADOG_ENVIRONMENTS);
    // Handle non-string types gracefully
    if (typeof env !== 'string') {
        return false;
    }
    const trimmedEnv = env.trim();
    return Boolean(trimmedEnv && validEnvironments.includes(trimmedEnv));
}
export function resolveValidDatadogEnvironment(env) {
    if (!isValidDatadogEnvironment(env)) {
        throw new InvalidDatadogEnvironmentError(env);
    }
    // We know env is a valid string at this point, so safe to trim
    return env.trim();
}
export function safeResolveValidDatadogEnvironment(env) {
    try {
        return resolveValidDatadogEnvironment(env);
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=validators.js.map